import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { uploadImageApi } from "../uploadImage/uploadImageAction";
import { addCompanyApi } from "./companyAction";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Swal from "sweetalert";
import ImageUploader from "react-images-upload";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import '../../../../../il8n';


const AddCompany = (props) => {
  const { t, i18n } = useTranslation();
  const [companyName, setCompanyName] = useState("");
  const [location, setCompanyLocation] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [VATNumber, setVATNumber] = useState(0);
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  const handleVisible = (msg) => {
    setAlertVisible(true)
    setTimeout(() => {
      setAlertVisible(false)
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  }
  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true)
    setTimeout(() => {
      setDangerVisibleAlert(false)
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  }
  const onDrop = (pictureFiles) => {
    props.uploadImageApi({
      image: pictureFiles[0],
    });
  };
  function saveCompany() {
    props.addCompanyApi({
      companyName: companyName,
      location: location,
      phone: phone,
      description: description,
      image: _.isEmpty(props.UploadImageURL) ? "" : props.UploadImageURL[0].file,
      ntn: VATNumber,
      email: email,
    },
      handleVisible,
      handleDangerVisible
    );
    setCompanyName("")
    setCompanyLocation("")
    setPhone("")
    setDescription("")
    setEmail("")
    setVATNumber("")
  }

  useEffect(() => {
    props.setHeading("Add Company");
  });

  return (
    <>
      {props.isAddingCompany ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="border"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <div>
              <Form>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('CompanyName')} *</b></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Company Name"
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('CompanyLocation')} *</b></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Company Location"
                        onChange={(e) => { setCompanyLocation(e.target.value) }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('Phone')} *</b></Form.Label>
                      <Form.Control
                        type="Number"
                        placeholder="Phone"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('Email')} *</b></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('Description')} </b></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Description"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana" >
                      <Form.Label><b>{t('VATNumber')} </b></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="VAT Number"
                        onChange={(e) => setVATNumber(e.target.value)} />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Form.Group className="mb-3">
                      <Form.Label><b style={{ fontSize: "large" }}> {t('UploadCompanyLogo')} </b> </Form.Label>
                      <ImageUploader
                        withIcon={false}
                        buttonText="Upload Company Logo"
                        onChange={onDrop}
                        imgExtension={[".jpg", ".jpeg", ".png"]}
                        maxFileSize={999999999999999999999}
                        singleImage={true}
                        withPreview={true}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  {_.isEmpty(companyName) || _.isEmpty(location) || _.isEmpty(phone) || _.isEmpty(email) ? (
                    <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                  ) : (
                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={saveCompany}> SAVE </Button>
                  )}
                </div>

              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCompanyApi: (data, handleVisible, handleDangerVisible) => dispatch(addCompanyApi(data, handleVisible, handleDangerVisible)),
    setHeading: (data) => dispatch(setHeading(data)),
    uploadImageApi: (data) => dispatch(uploadImageApi(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  companyList: state.CompanyReducer.companyList,
  isAddingCompany: state.CompanyReducer.isAddingCompany,
  UploadImageURL: state.UploadImageReducer.UploadImageURL,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCompany);